import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://vdqcpjnfxcnizufuvvrk.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZkcWNwam5meGNuaXp1ZnV2dnJrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI5MTA2ODAsImV4cCI6MjA4ODQ4NjY4MH0.QzNGxq5-YnQS-Dw2UZ36Pn_PpugfxMxDbKDKaE5gYeo';

export const supabase = createClient(supabaseUrl, supabaseKey);
